import { Component, Input } from '@angular/core';
import { DashboardActionType, DashboardWidgetActionData, DashboardWidgetData } from '../../../../domain/model/dashboard.model';
import { Router } from '@angular/router';
import { ActionButtonColor, ActionButtonType } from '@partner/shared/models/action-button/action-button.model';

@Component({
    selector: 'ifbp-dashboard-widget',
    templateUrl: './dashboard-widget.component.html',
    styleUrls: ['./dashboard-widget.component.scss'],
    standalone: false
})
export class DashboardWidgetComponent {
  @Input()
  data: DashboardWidgetData;

  readonly ButtonType = ActionButtonType;
  readonly ButtonColor = ActionButtonColor;
  readonly ActionType = DashboardActionType;

  constructor(private router: Router) { }

  /** Actions carry no id; the label is the only stable key the API sends. */
  trackByAction(index: number, action: DashboardWidgetActionData): string | number {
    return action?.label ?? index;
  }

  onClickAction(data: DashboardWidgetActionData) {
    switch (data.type) {
      case DashboardActionType.RedirectExternal:
        return window.open(data.redirectUrl, "_blank");

      case DashboardActionType.RedirectInternal:
        return this.router.navigate([data.redirectUrl]);

      default:
        break;
    }
  }
}
